import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button } from "../../Button";
import { DisplayText } from "../../DisplayText";
import { Icon } from "../../Icon";
import * as S from "../Modal.styled";
export var ModalHeader = function (props) {
    var type = props.type, heading = props.heading, component = props.component, onClose = props.onClose, hasDismiss = props.hasDismiss;
    if (!component && !heading) {
        return null;
    }
    if (component && heading) {
        return null;
    }
    if (component) {
        // @ts-ignore
        return React.createElement(component, {
            onClose: onClose,
            hasDismiss: hasDismiss,
        });
    }
    return (_jsxs(S.Header, { type: type, children: [_jsx("div", { children: _jsx(DisplayText, { size: "large", children: heading }) }), hasDismiss && (_jsx(Button, { appearance: "plain", onClick: onClose, children: _jsx(Icon, { source: "close" }) }))] }));
};
